import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const NAV_LINKS: { label: string; href: string; route?: boolean }[] = [
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Features', href: '#features' },
  { label: 'Security', href: '#security' },
  { label: 'API Docs', href: '/api-docs', route: true },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollTo = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      const container = el.closest('[style*="zoom"]') as HTMLElement | null;
      const zoom = container ? parseFloat(container.style.zoom || '1') : 1;
      const navHeight = 64;
      const top = el.getBoundingClientRect().top / zoom + window.scrollY - navHeight / zoom;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-sm border-b border-navy-800/50" style={{ backgroundColor: 'rgba(26,35,50,0.92)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 sm:h-16 flex items-center justify-between">
        <Link to="/" className="font-mono text-bone-white tracking-widest text-sm font-medium">
          BONESPAY
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map(({ label, href, route }) =>
            route ? (
              <Link
                key={href}
                to={href}
                className="font-mono text-xs text-bone-white/60 hover:text-bone-white transition-colors uppercase tracking-wider"
              >
                {label}
              </Link>
            ) : (
              <button
                key={href}
                onClick={() => scrollTo(href)}
                className="font-mono text-xs text-bone-white/60 hover:text-bone-white transition-colors uppercase tracking-wider"
              >
                {label}
              </button>
            )
          )}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <Link
            to="/login"
            className="font-mono text-xs text-bone-white/60 hover:text-bone-white transition-colors uppercase tracking-wider"
          >
            Sign In
          </Link>
          <Link
            to="/apply"
            className="font-mono text-xs font-medium bg-bone-white text-navy-900 px-5 py-2 rounded-subtle hover:bg-navy-100 transition-colors uppercase tracking-wider"
          >
            Apply Now
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-bone-white/60 hover:text-bone-white"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-navy-950 border-t border-navy-800/50 px-4 sm:px-6 py-4 space-y-1">
          {NAV_LINKS.map(({ label, href, route }) =>
            route ? (
              <Link
                key={href}
                to={href}
                onClick={() => setMobileOpen(false)}
                className="block w-full text-left font-mono text-xs text-bone-white/60 hover:text-bone-white transition-colors uppercase tracking-wider py-2.5"
              >
                {label}
              </Link>
            ) : (
              <button
                key={href}
                onClick={() => scrollTo(href)}
                className="block w-full text-left font-mono text-xs text-bone-white/60 hover:text-bone-white transition-colors uppercase tracking-wider py-2.5"
              >
                {label}
              </button>
            )
          )}
          <div className="pt-3 mt-1 border-t border-navy-800/50 flex flex-col gap-3">
            <Link to="/login" className="font-mono text-xs text-bone-white/60 hover:text-bone-white uppercase tracking-wider py-2">
              Sign In
            </Link>
            <Link
              to="/apply"
              className="font-mono text-xs font-medium bg-bone-white text-navy-900 px-5 py-2.5 rounded-subtle text-center hover:bg-navy-100 transition-colors uppercase tracking-wider"
            >
              Apply Now
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
